import { render, staticRenderFns } from "./my-image.vue?vue&type=template&id=511acbfe&scoped=true&"
import script from "./my-image.vue?vue&type=script&lang=js&"
export * from "./my-image.vue?vue&type=script&lang=js&"
import style0 from "./my-image.vue?vue&type=style&index=0&id=511acbfe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511acbfe",
  null
  
)

export default component.exports